export default {
    filterByStatusOption(state, data) {
        state.filterByStatusOption = data
    },
    systemUsersfields(state, data) {
        state.systemUsersfields = data
    },
    setUsersList(state, data) {
        state.usersList = data
    },
}
